import { css as v, LitElement as h, html as u, nothing as m } from "lit";
import { property as s, customElement as f } from "lit/decorators.js";
import { b as g } from "./styles-scZ6dVz-.js";
import { classMap as b } from "lit/directives/class-map.js";
var y = Object.defineProperty, x = Object.getOwnPropertyDescriptor, p = (a, e, t, i) => {
  for (var r = i > 1 ? void 0 : i ? x(e, t) : e, l = a.length - 1, n; l >= 0; l--)
    (n = a[l]) && (r = (i ? n(e, t, r) : n(r)) || r);
  return i && r && y(e, t, r), r;
};
let d = class extends h {
  constructor() {
    super(...arguments), this.type = "single", this.collapsible = !0, this.value = [], this.defaultValue = [], this._initialized = !1, this.handleItemToggle = (a) => {
      const { value: e, expanded: t } = a.detail;
      this.type === "single" ? t ? this.value = [e] : this.collapsible && (this.value = []) : t ? this.value = [...this.value, e] : this.value = this.value.filter((i) => i !== e), this.dispatchEvent(
        new CustomEvent("ark-change", {
          detail: { value: this.value },
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("ark-item-toggle", this.handleItemToggle);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("ark-item-toggle", this.handleItemToggle);
  }
  firstUpdated() {
    !this._initialized && this.defaultValue.length > 0 && (this.value = [...this.defaultValue], this._initialized = !0), this.updateItems();
  }
  updated(a) {
    a.has("value") && this.updateItems();
  }
  updateItems() {
    this.querySelectorAll("ark-accordion-item").forEach((e) => {
      const t = e;
      t.value && (t.expanded = this.value.includes(t.value));
    });
  }
  render() {
    return u`
      <div part="accordion" class="accordion" role="region">
        <slot></slot>
      </div>
    `;
  }
};
d.styles = [
  g,
  v`
      :host {
        display: block;
      }

      .accordion {
        display: flex;
        flex-direction: column;
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        overflow: hidden;
        background-color: var(--r5-surface);
      }

      ::slotted(ark-accordion-item:not(:last-child)) {
        border-bottom: 1px solid var(--r5-border);
      }
    `
];
p([
  s({ type: String, reflect: !0 })
], d.prototype, "type", 2);
p([
  s({ type: Boolean, reflect: !0 })
], d.prototype, "collapsible", 2);
p([
  s({ type: Array })
], d.prototype, "value", 2);
p([
  s({ type: Array, attribute: "default-value" })
], d.prototype, "defaultValue", 2);
d = p([
  f("ark-accordion")
], d);
var w = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, c = (a, e, t, i) => {
  for (var r = i > 1 ? void 0 : i ? $(e, t) : e, l = a.length - 1, n; l >= 0; l--)
    (n = a[l]) && (r = (i ? n(e, t, r) : n(r)) || r);
  return i && r && w(e, t, r), r;
};
let o = class extends h {
  constructor() {
    super(...arguments), this.value = "", this.title = "", this.expanded = !1, this.disabled = !1, this.chevronIcon = u`
    <svg
      class="chevron"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  `;
  }
  handleToggle() {
    this.disabled || this.dispatchEvent(
      new CustomEvent("ark-item-toggle", {
        detail: { value: this.value, expanded: !this.expanded },
        bubbles: !0,
        composed: !0
      })
    );
  }
  render() {
    const a = {
      item: !0,
      expanded: this.expanded,
      disabled: this.disabled
    }, e = `content-${this.value}`, t = `header-${this.value}`;
    return u`
      <div part="item" class=${b(a)}>
        <div part="header" class="header">
          <button
            part="trigger"
            class="trigger"
            type="button"
            id=${t}
            aria-expanded=${this.expanded}
            aria-controls=${e}
            ?disabled=${this.disabled}
            @click=${this.handleToggle}
          >
            <span class="trigger-content">
              <slot name="icon"></slot>
              <span class="title">
                <slot name="header">
                  ${this.title}
                  ${this.subtitle ? u`<div class="subtitle">${this.subtitle}</div>` : m}
                </slot>
              </span>
            </span>
            <span part="icon">${this.chevronIcon}</span>
          </button>
        </div>
        <div
          part="content"
          class="content"
          id=${e}
          role="region"
          aria-labelledby=${t}
          aria-hidden=${!this.expanded}
        >
          <div part="panel" class="panel">
            <div class="panel-inner">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }
};
o.styles = [
  g,
  v`
      :host {
        display: block;
      }

      .item {
        background-color: var(--r5-surface);
      }

      .header {
        display: flex;
        width: 100%;
      }

      .trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: var(--r5-space-4) var(--r5-space-5);
        background: transparent;
        border: none;
        cursor: pointer;
        text-align: left;
        font-family: var(--r5-font-body);
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text);
        transition: background-color var(--r5-duration-fast) var(--r5-ease-default);
      }

      .trigger:hover {
        background-color: var(--r5-bg-muted);
      }

      .trigger:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: calc(-1 * var(--r5-focus-ring-width));
      }

      .trigger:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }

      .trigger-content {
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
        flex: 1;
        min-width: 0;
      }

      .title {
        flex: 1;
        min-width: 0;
      }

      .subtitle {
        font-size: var(--r5-text-xs);
        font-weight: var(--r5-font-normal);
        color: var(--r5-text-muted);
        margin-top: var(--r5-space-0-5);
      }

      .chevron {
        flex-shrink: 0;
        width: 1rem;
        height: 1rem;
        color: var(--r5-text-muted);
        transition: transform var(--r5-duration-normal) var(--r5-ease-out);
      }

      .expanded .chevron {
        transform: rotate(180deg);
      }

      .content {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows var(--r5-duration-normal) var(--r5-ease-out);
      }

      .expanded .content {
        grid-template-rows: 1fr;
      }

      .panel {
        overflow: hidden;
      }

      .panel-inner {
        padding: 0 var(--r5-space-5) var(--r5-space-4);
        color: var(--r5-text-muted);
        font-size: var(--r5-text-sm);
        line-height: var(--r5-leading-relaxed);
      }

      @media (prefers-reduced-motion: reduce) {
        .chevron,
        .content {
          transition: none;
        }
      }
    `
];
c([
  s({ type: String, reflect: !0 })
], o.prototype, "value", 2);
c([
  s({ type: String })
], o.prototype, "title", 2);
c([
  s({ type: String })
], o.prototype, "subtitle", 2);
c([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "expanded", 2);
c([
  s({ type: Boolean, reflect: !0 })
], o.prototype, "disabled", 2);
o = c([
  f("ark-accordion-item")
], o);
export {
  d as A,
  o as a
};
//# sourceMappingURL=ark-accordion-item-I_HjdR_P.js.map
